const map = {
	"./0.svg": 36593,
	"./1.svg": 640,
	"./2.svg": 21395,
	"./3.svg": 16226,
	"./4.svg": 86445,
	"./5.svg": 65119,
	"./6.svg": 66527,
	"./7.svg": 38094,
	"./win.svg": 26359
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55889;